import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgUploaderModule } from 'ngx-uploader';
import { Routes, RouterModule } from '@angular/router'; 
import { Http, HttpModule } from "@angular/http";

import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { HomeComponent } from './home/home.component';
import { TableComponent } from './osiguranja/osiguranja.component';
import { UploadComponent } from 'app/home/homeUpload.component';
import { IzvestajComponent } from "app/izvestaj/izvestaj.component";
import { KorisniciComponent } from "app/korisnici/korisnici.component";
import { ProfilComponent } from "app/profil/profil.component";




const appRoutes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'osiguranja',
    component: TableComponent
  },
  {
    path: 'izvestaj',
    component: IzvestajComponent
  },
  {
    path: 'korisnici',
    component: KorisniciComponent
  },
  {
    path: 'profil',
    component: ProfilComponent
  }
];

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    HomeComponent,
    TableComponent,
    UploadComponent,
    IzvestajComponent,
    KorisniciComponent,
    ProfilComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    FormsModule,
    HttpModule,
    NgUploaderModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/re5pect/Desktop/siterepoProject/Admin panel/SiteRepoAdminPanel/src/app/app.module.ts